module.exports = __webpack_public_path__ + "static/flaming_fist_coat_of_arms-f1eea4975b49e31a1d6f6e692f411b44.webp";